import { type FC } from "react";
import * as styles from "@legacy_user_frontend/components/pages/jobs/job_search_navigation/src/search_modal/modal_contents/src/styles.css";

type Props = {
  url: string;
  isTitleLink?: boolean;
};

export const ModalLink: FC<Props> = ({ url, isTitleLink }) => (
  <a
    className={`js-link-expand__target ${isTitleLink ? styles.titleLink : styles.link}`}
    href={url}
  >
    <i className="c-icn c-icn-arrow-light-right" />
  </a>
);
